/**
 * Modern Propane — cart delivery ZIP enforcement + order note assembly.
 */
(function () {
  'use strict';

  var ZIP_KEY = 'mp_zip';

  function isZip(value) {
    return /^\d{5}$/.test(String(value || '').trim());
  }

  function loadStoredZip() {
    try {
      return localStorage.getItem(ZIP_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function saveStoredZip(zip) {
    try {
      localStorage.setItem(ZIP_KEY, zip);
    } catch (e) {
      /* ignore */
    }
  }

  function stripDeliveryBlock(note) {
    if (!note) return '';
    var marker = '--- Delivery information ---';
    var idx = note.indexOf(marker);
    if (idx === -1) return note.trim();
    return note.slice(0, idx).trim();
  }

  function buildOrderNote(config) {
    var parts = ['--- Delivery information ---'];
    parts.push('Delivery ZIP: ' + config.zip);
    parts.push('Delivery services: ' + config.servicesLabel);
    if (config.deliveryNotes) {
      parts.push('Customer notes: ' + config.deliveryNotes);
    }
    parts.push('---');
    if (config.existingNote) {
      parts.push(config.existingNote);
    }
    return parts.join('\n');
  }

  function updateCart(payload) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    });
  }

  function initCartDelivery() {
    var panel = document.querySelector('[data-mp-cart-delivery]');
    var form = document.querySelector('form.cart');
    if (!panel || !form) return;

    var zipInput = panel.querySelector('[data-mp-cart-delivery-zip]');
    var notesInput = panel.querySelector('[data-mp-cart-delivery-notes]');
    var errorEl = panel.querySelector('[data-mp-cart-delivery-error]');
    var scheduleEl = panel.querySelector('[data-mp-cart-delivery-schedule]');
    var cartNotes = document.querySelector('[data-cart-notes]');
    var servicesLabel = panel.getAttribute('data-delivery-label') || panel.getAttribute('data-delivery-types') || '';

    if (!zipInput) return;

    if (!zipInput.value && isZip(loadStoredZip())) {
      zipInput.value = loadStoredZip();
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
      panel.classList.add('mp-cart-delivery--error');
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
      panel.classList.remove('mp-cart-delivery--error');
    }

    function renderSchedule() {
      if (!scheduleEl) return;
      var zip = zipInput.value.trim();
      if (!isZip(zip)) {
        scheduleEl.hidden = true;
        scheduleEl.textContent = '';
        return;
      }

      if (!window.MPDeliveryZip) {
        scheduleEl.hidden = false;
        scheduleEl.textContent = 'ZIP saved — our team will confirm delivery availability at checkout.';
        return;
      }

      window.MPDeliveryZip.lookup(zip)
        .then(function (entry) {
          if (!entry) {
            scheduleEl.hidden = false;
            scheduleEl.textContent = 'ZIP saved — our team will confirm delivery availability at checkout.';
            return;
          }
          scheduleEl.hidden = false;
          scheduleEl.textContent = window.MPDeliveryZip.formatCartSchedule(entry);
        })
        .catch(function () {
          scheduleEl.hidden = false;
          scheduleEl.textContent = 'ZIP saved — our team will confirm delivery availability at checkout.';
        });
    }

    function persistAttributes(options) {
      var zip = zipInput.value.trim();
      var deliveryNotes = notesInput ? notesInput.value.trim() : '';
      var existingNote = cartNotes ? stripDeliveryBlock(cartNotes.value.trim()) : stripDeliveryBlock('');

      var attributes = {
        'Delivery ZIP': zip,
        'Delivery services': servicesLabel
      };
      if (deliveryNotes) {
        attributes['Customer delivery notes'] = deliveryNotes;
      } else {
        attributes['Customer delivery notes'] = '';
      }

      var payload = { attributes: attributes };
      if (options && options.includeNote && isZip(zip)) {
        payload.note = buildOrderNote({
          zip: zip,
          servicesLabel: servicesLabel,
          deliveryNotes: deliveryNotes,
          existingNote: existingNote
        });
        if (cartNotes) {
          cartNotes.value = payload.note;
        }
      }

      return updateCart(payload);
    }

    zipInput.addEventListener('input', function () {
      clearError();
      renderSchedule();
    });

    zipInput.addEventListener('blur', function () {
      var zip = zipInput.value.trim();
      if (!isZip(zip)) return;
      saveStoredZip(zip);
      persistAttributes({ includeNote: false }).catch(function () {
        /* non-blocking */
      });
      renderSchedule();
    });

    if (notesInput) {
      notesInput.addEventListener('blur', function () {
        persistAttributes({ includeNote: false }).catch(function () {
          /* non-blocking */
        });
      });
    }

    form.addEventListener(
      'submit',
      function (event) {
        var submitter = event.submitter;
        var isCheckout =
          submitter &&
          (submitter.name === 'checkout' ||
            submitter.classList.contains('cart__submit') ||
            submitter.value === 'Check out');

        if (!isCheckout) return;

        event.preventDefault();
        event.stopPropagation();

        var zip = zipInput.value.trim();
        if (!isZip(zip)) {
          showError('Please enter a valid 5-digit delivery ZIP code before checkout.');
          zipInput.focus();
          return;
        }

        clearError();
        saveStoredZip(zip);

        var deliveryNotes = notesInput ? notesInput.value.trim() : '';
        var existingNote = cartNotes ? stripDeliveryBlock(cartNotes.value.trim()) : '';
        var orderNote = buildOrderNote({
          zip: zip,
          servicesLabel: servicesLabel,
          deliveryNotes: deliveryNotes,
          existingNote: existingNote
        });

        if (cartNotes) {
          cartNotes.value = orderNote;
        }

        updateCart({
          note: orderNote,
          attributes: {
            'Delivery ZIP': zip,
            'Delivery services': servicesLabel,
            'Customer delivery notes': deliveryNotes
          }
        })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function () {
            showError('Could not save delivery details. Please try again.');
          });
      },
      true
    );

    if (window.MPDeliveryZip && window.MPDeliveryZip.loadData) {
      window.MPDeliveryZip.loadData().then(renderSchedule).catch(renderSchedule);
    } else {
      renderSchedule();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDelivery);
  } else {
    initCartDelivery();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail && event.detail.sectionId) {
      initCartDelivery();
    }
  });
})();
